module.exports = __webpack_public_path__ + "img/居住地真实性-影像信息@2x.d93ce62a.png";